module.exports = __webpack_public_path__ + "img/location.4e302f75.png";